<template>
  <div class="dashboard p-4">
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Vehicle Detection Dashboard
          </h1>
        </div>
      </div>
    </div>

    <!-- Metrics Cards -->
    <div
      class="wrapper-card grid lg:grid-cols-2 grid-cols-1 md:grid-cols-2 gap-2 mt-5"
    >
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-orange-200 rounded-full w-14 h-14 text-lg p-3 text-orange-600 mx-auto"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M10 16V8a2 2 0 0 1 2-2h9V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-1h-9a2 2 0 0 1-2-2zm3-8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h9V8h-9zm3 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
              />
            </svg>
          </div>
        </div>
        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ totalDetections }}
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">
            Total Detections Today
          </h2>
        </div>
      </div>
      <!-- Repeated Vehicles -->
<!-- <div class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex">
  <div class="p-2 max-w-sm">
    <div class="bg-teal-200 rounded-full w-14 h-14 text-lg p-3 text-teal-600 mx-auto">
      🔁
    </div>
  </div>
  <div class="block p-2 w-full">
    <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
      {{ repeatedVehicleCount }}
    </p>
    <h2 class="font-normal text-gray-400 text-md mt-1">Repeated Vehicles</h2>
  </div>
</div> -->

<!-- Zone A Detections -->
<div class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex">
  <div class="p-2 max-w-sm">
    <div class="bg-cyan-200 rounded-full w-14 h-14 text-lg p-3 text-cyan-600 mx-auto">
      🛣️
    </div>
  </div>
  <div class="block p-2 w-full">
    <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
      {{ zoneCounts['Zone A'] || 0 }}
    </p>
    <h2 class="font-normal text-gray-400 text-md mt-1">Zone A Coverage</h2>
  </div>
</div>
    </div>
      <!-- Video Feed and Live Alerts -->
      <div class="mt-2 lg:flex block lg:gap-2 relative">
        <div class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden">
          <h1 class="text-center text-lg font-semibold mb-2">Live Feed - 1</h1>
          <img :src="videoFeedUrl" class="rounded-md w-full h-[400px] object-cover" alt="Live Vehicle Feed" />
        </div>
        <div class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden">
          <h1 class="text-center text-lg font-semibold mb-2">Live Feed - 2</h1>
          <img :src="videoFeedUrl" class="rounded-md w-full h-[400px] object-cover" alt="Live Vehicle Feed" />
        </div>
        <!-- <div class="bg-white dark:bg-gray-800 p-5 lg:mt-0 mt-4 lg:w-2/4 border dark:border-gray-700 rounded-md w-full">
          <div>
            <h2 class="text-lg font-semibold dark:text-gray-200">Live Alerts</h2>
          </div>
          <perfect-scrollbar class="divide-y h-96 mt-5 dark:divide-gray-700">
            <div class="p-3 w-full" v-for="(alert, index) in detections" :key="index">
              <div class="bg-green-100 p-4 rounded-lg cursor-pointer">
                <div class="text-sm text-gray-600 font-bold">
                   {{ alert.class_name }} detected at {{ formatIST(alert.timestamp) }}
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div> -->
      </div>
  <!-- charts -->

    <!-- Charts -->
    <div class="wrapper-chart mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
        <!-- Pie Chart -->
        <div class="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white mb-2">Vehicle Type Distribution (Pie)</h2>
          <apexchart width="100%" height="300" type="pie" :options="optionsPie" :series="seriesPie"></apexchart>
        </div>
  
        <!-- Bar Chart -->
        <div class="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white mb-2">Vehicle Count by Class (Bar)</h2>
          <apexchart width="100%" height="300" type="bar" :options="optionsBar" :series="seriesBar"></apexchart>
        </div>
  
        <!-- Line Chart -->
        <div class="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white mb-2">Confidence Over Time (Line)</h2>
          <apexchart width="100%" height="300" type="line" :options="optionsLine" :series="seriesLine"></apexchart>
        </div>
      </div>
    <!-- Recent Detection Table -->
    <div class="mt-5 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Recent Detections
          </h1>
        </div>
        <div class="flex gap-2">
            <div class="flex gap-2">
                <button
                  class="bg-primary border flex gap-2 text-white hover:bg-primary/80 dark:border-gray-700 rounded py-3 px-5"
                  @click="exportToCSV"
                >
                  <span class="icon text-2xl"></span>
                  <span class="text">Export Report CSV</span>
                </button>
              </div>
          <button
            class="bg-primary border flex gap-2 text-white hover:bg-primary/80 dark:border-gray-700 rounded py-3 px-5"
            @click="exportToPDF"
          >
            <span class="icon text-2xl"></span>
            <span class="text">Export Report PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div>
      <!-- Filters -->
      <div class="flex flex-wrap items-center gap-4 mb-4">
        <input
          type="datetime-local"
          v-model="filters.start"
          class="border px-3 py-2 rounded-md dark:bg-gray-800 dark:text-white"
        />
        <span>to</span>
        <div class="flex flex-col">
          <input
            type="datetime-local"
            v-model="filters.end"
            class="border px-3 py-2 rounded-md dark:bg-gray-800 dark:text-white"
          />
        </div>
        <button
          @click="clearFilters"
          type="button"
          class="text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
        >
          Clear
        </button>
        <div class="mb-2">
          <input
            type="text"
            v-model="filters.search"
            placeholder="Search"
            class="border px-3 py-2 rounded-md dark:bg-gray-800 dark:text-white w-64"
          />
        </div>
      </div>

      <table
        class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 shadow-md rounded-lg"
      >
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400 border-b"
        >
          <tr>
            <th class="px-6 py-3 border-r">Image</th>
            <th class="px-6 py-3 border-r">Tracker ID</th>
            <th class="px-6 py-3 border-r">Class</th>
            <th class="px-6 py-3 border-r">Confidence (%)</th>
            <th class="px-6 py-3 border-r">Timestamp</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in paginatedDetections"
            :key="item.id"
            class="bg-white dark:bg-gray-800 border-b hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <td class="px-6 py-4 border-r">
              <img
                :src="`http://127.0.0.1:5000/detected_vehicle/${item.file}`"
                alt="vehicle"
                class="w-16 h-16 rounded object-cover"
              />
            </td>
            <td class="px-6 py-4 border-r">{{ item.tracker_id }}</td>
            <td class="px-6 py-4 border-r">{{ item.class_name }}</td>
            <td class="px-6 py-4 border-r">{{ item.confidence.toFixed(2) }}</td>
            <td class="px-6 py-4">{{ formatIST(item.timestamp) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="flex justify-end items-center mt-4 space-x-2">
        <!-- Pagination per page entry display -->
        <div class="mt-4 mb-2">
          <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Entries per page
            <select
              v-model.number="perPage"
              class="ml-2 border px-2 py-1 rounded-md dark:bg-gray-800 dark:text-white"
            >
              <option :value="5">5</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
          </label>
        </div>
        <button
          @click="currentPage--"
          :disabled="currentPage === 1"
          class="px-3 py-1 border rounded bg-gray-200 dark:bg-gray-700"
        >
          Prev
        </button>
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          @click="currentPage++"
          :disabled="currentPage === totalPages"
          class="px-3 py-1 border rounded bg-gray-200 dark:bg-gray-700"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useDashboardStore } from "../store/useVehicleStore";
import jsPDF from "jspdf";
import ApexCharts from "vue3-apexcharts";


export default {
  data() {
    return {
      store: useDashboardStore(),
      filters: {
        start: "",
        end: "",
        search: "",
      },
      currentPage: 1,
      perPage: 5,
    };
  },
  watch: {
  'store.detections': {
    handler(newVal) {
      console.log("Detections updated:", newVal.length);
    },
    deep: true,
    immediate: true
  }
},
  computed: {
    zoneCounts() {
  return this.filteredDetections.reduce((acc, curr) => {
    // 👇 Example logic to assign zone
    let zone = "Zone A";
    if (curr.tracker_id % 3 === 0) zone = "Zone B";
    if (curr.tracker_id % 5 === 0) zone = "Zone C";

    acc[zone] = (acc[zone] || 0) + 1;
    return acc;
  }, {});
},
repeatedVehicleCount() {
  const trackerMap = {};
  this.filteredDetections.forEach((d) => {
    if (!d.tracker_id) return;
    trackerMap[d.tracker_id] = (trackerMap[d.tracker_id] || 0) + 1;
  });

  console.log("Repeated Count:", trackerMap); // debug
  return Object.values(trackerMap).filter((count) => count > 1).length;
},
    videoFeedUrl() {
      return this.store.videoFeedUrl;
    },
    totalDetections() {
  const today = new Date().toISOString().split("T")[0]; // Get current date: yyyy-mm-dd
  return this.store.detections.filter((d) => {
    const detectionDate = new Date(d.timestamp).toISOString().split("T")[0];
    return detectionDate === today;
  }).length;
},
    filteredDetections() {
      return this.store.detections.filter((d) => {
        const t = new Date(d.timestamp);
        const from = this.filters.start ? new Date(this.filters.start) : null;
        const to = this.filters.end ? new Date(this.filters.end) : null;
        const matchTime = (!from || t >= from) && (!to || t <= to);

        const search = this.filters.search.toLowerCase();
        const matchSearch =
          search === "" ||
          String(d.tracker_id).toLowerCase().includes(search) ||
          d.class_name.toLowerCase().includes(search) ||
          d.confidence.toFixed(2).includes(search);

        return matchTime && matchSearch;
      });
    },
    paginatedDetections() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredDetections.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.filteredDetections.length / this.perPage);
    },
    detections() {
    return this.store.detections;
  },
      // Chart Data
      optionsPie() {
      return {
        labels: Object.keys(this.classCounts),
        legend: { position: 'bottom' },
      };
    },
    seriesPie() {
      return Object.values(this.classCounts);
    },
    optionsBar() {
      return {
        chart: { id: 'bar' },
        xaxis: { categories: Object.keys(this.classCounts) },
      };
    },
    seriesBar() {
      return [{
        name: 'Vehicle Count',
        data: Object.values(this.classCounts),
      }];
    },
    optionsLine() {
      return {
        chart: { id: 'line' },
        xaxis: { categories: this.filteredDetections.map(d => d.class_name) },
      };
    },
    seriesLine() {
      return [{
        name: 'Confidence',
        data: this.filteredDetections.map(d => d.confidence.toFixed(2)),
      }];
    },
    classCounts() {
      return this.filteredDetections.reduce((acc, curr) => {
        acc[curr.class_name] = (acc[curr.class_name] || 0) + 1;
        return acc;
      }, {});
    },
  },
  methods: {
    clearFilters() {
      this.filters.start = "";
      this.filters.end = "";
      this.filters.search = "";
    },
    formatIST(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    },
    exportToPDF() {
  const doc = new jsPDF();
  const brandName = "Logic Clutch Software LLP";
  const reportTitle = "Vehicle Detection Report";
  const logoPath = "/lc_logo.png";

  const img = new Image();
  img.src = logoPath;
  img.onload = () => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Header
    doc.addImage(img, "PNG", 10, 10, 30, 30);
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text(brandName, 45, 25);

    // Title
    doc.setFontSize(22);
    doc.setTextColor(40, 40, 40);
    doc.text(reportTitle, 10, 50);

    doc.setLineWidth(0.5);
    doc.line(10, 55, 200, 55);

    // Watermark
    doc.setGState(new doc.GState({ opacity: 0.15 }));
    doc.addImage(img, "PNG", pageWidth / 4, pageHeight / 4, 100, 100, "", "FAST");
    doc.setGState(new doc.GState({ opacity: 1 }));

    const tableStartY = 65;
    const tableColumn = ["Tracker ID", "Class", "Confidence (%)", "Timestamp"];
    const tableRows = this.paginatedDetections.map((log) => [
      log.tracker_id,
      log.class_name,
      log.confidence.toFixed(2),
      this.formatIST(log.timestamp),
    ]);

    let y = tableStartY;

    // Table Headers
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setFillColor(50, 50, 150);
    doc.setTextColor(255, 255, 255);
    doc.rect(10, y - 5, 190, 8, "F");

    tableColumn.forEach((col, index) => {
      doc.text(col, 15 + index * 45, y);
    });

    y += 10;

    // Table Rows
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    tableRows.forEach((row, rowIndex) => {
      doc.setFillColor(rowIndex % 2 === 0 ? 245 : 230, 230, 230);
      doc.setTextColor(0, 0, 0);
      doc.rect(10, y - 5, 190, 8, "F");

      row.forEach((cell, index) => {
        doc.text(String(cell), 15 + index * 45, y);
      });

      y += 10;
    });

    doc.setLineWidth(0.5);
    doc.line(10, y + 5, 200, y + 5);

    doc.save("Vehicle_Detection_Report.pdf");
  };

  img.onerror = () => {
    console.error("Error loading the logo image. Make sure it's in the public folder.");
  };
},
exportToCSV() {
  const headers = ['Tracker ID', 'Class', 'Confidence (%)', 'Timestamp'];
  const rows = this.paginatedDetections.map(log => [
    log.tracker_id,
    log.class_name,
    log.confidence.toFixed(2),
    this.formatIST(log.timestamp),
  ]);

  let csvContent = headers.join(',') + '\n';
  rows.forEach(row => {
    csvContent += row.join(',') + '\n';
  });

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', 'Vehicle_Detection_Report.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



  },
  mounted() {
    this.store.fetchDetections();
    setInterval(() => this.store.fetchDetections(), 5000);
  },
};
</script>

<style scoped>
/* Optional scoped CSS */
</style>
